import dayjs from 'dayjs';

type TCryptoCurrenciesMapping = Record<
  string,
  { chainId: number; currency: string }
>;

export const CRYPTO_CURRENCIES_MAPPING: TCryptoCurrenciesMapping = {
  FTNF: {
    chainId: 5165,
    currency: 'FTN'
  },
  USDT: {
    chainId: 1,
    currency: 'USDT'
  },
  USDC: {
    chainId: 1,
    currency: 'USDC'
  },
  ETH: {
    chainId: 1,
    currency: 'ETH'
  },
  BUSD: {
    chainId: 1,
    currency: 'BUSD'
  },
  BNB: {
    chainId: 1,
    currency: 'BNB'
  },
  SHIB: {
    chainId: 1,
    currency: 'SHIB'
  },
  FTN: {
    chainId: 1,
    currency: 'FTN'
  },
  DAI: {
    chainId: 1,
    currency: 'DAI'
  },
  USDT_T: {
    chainId: 0,
    currency: 'USDT'
  },
  USDB: {
    chainId: 0,
    currency: 'USDT'
  }
};

export type stakeRewardsType = {
  data: {
    date: dayjs.Dayjs;
    fee: number;
    balance: number;
    id: number;
  }[];
  nextUpdate: number;
  nextRewardTime: number;
};

export type stakeRateType = {
  yearly: number;
  monthly: number;
  daily: number;
};

export type stakeHistoryType = {
  data: {
    date: dayjs.Dayjs;
    amount: number;
    type: string;
    id: number;
  }[];
};
export type unStakeType = {
  message: string;
  status: string;
};

export type stakeBalanceType = {
  data: {
    balance: number;
    rate: number;
  };
};

export type stakeRecordItem = {
  date: dayjs.Dayjs;
  amount: number;
  type: string;
  id: number;
};

export type rewardType = {
  date: dayjs.Dayjs;
  fee: number;
  balance: number;
  key?: number;
  id: number;
};

export const fixedDigitForLolik = 5;

export const ALL_CRYPTO_CURRENCIES = [
  'BCH',
  'BNB',
  'BSS',
  'BSV',
  'BTC',
  'BTS',
  'CPC',
  'DAI',
  'DCP',
  'DOG',
  'DSH',
  'ETC',
  'ETH',
  'FST',
  'FTN',
  'GC',
  'GPT',
  'GVI',
  'GWI',
  'IIP',
  'KLW',
  'LTC',
  'MBT',
  'MET',
  'MTH',
  'NLC',
  'PBC',
  'QCB',
  'SHB',
  'SPC',
  'STH',
  'TRX',
  'TUS',
  'USC',
  'V01',
  'V02',
  'V03',
  'V04',
  'VBT',
  'VET',
  'VLC',
  'VM1',
  'VM2',
  'VVI',
  'WVI',
  'WWI',
  'XMR',
  'XRP',
  'YOS',
  'ZEC',
  'ZPT',
  'USA',
  'USDC'
];
